import {
    Button,
    Dropdown,
    formatNumber,
    getCalendarFormat,
    Icon,
    TDataTableColumnsData,
    TDataTableRowData
} from "@cakemail-org/ui-components-v2"
import { Stack } from "@mui/material"
import { t } from "i18next"
import { affixToPercent } from "../../utils/data"
import { TGetListingRowsList } from "./types"


export function getListingColsData(): () => TDataTableColumnsData[] {
    return () => [
        {
            id: "name",
            label: t("general-list_one"),
            sortable: true
        },
        {
            id: "subscribers",
            label: t("general-subscriber_other")
        },
        {
            id: "click_rate",
            label: t("general-click_rate"),
        },
        {
            id: "created_on",
            label: t("general-created_on"),
            sortable: true
        },
        {
            id: "actions",
            label: ""
        }
    ]
}

export function getListingRows({
    list,
    loading,
    handleViewContacts,
    handleEditList,
    handleRenameList,
    handleDeleteList,
    partialListReport,
    genericWrapper
}: TGetListingRowsList): TDataTableRowData {
    const actions: any = <Stack direction="row" gap={3}>
        <Button
            variant="outlined"
            size="small"
            color="body1"
            onClick={() => { handleViewContacts(list) }}
            iconOnly
            disabled={loading}
        >{t("general-view-contact_other")}</Button>
        <Dropdown
            size="medium"
            color="body1"
            variant="outlined"
            iconOnly
            options={[
                {
                    isAction: true,
                    text: t("general-edit"),
                    postContent: <Icon name="Edit18" />,
                    onClick: () => { handleEditList(list) }
                },
                {
                    isAction: true,
                    text: t("general-rename"),
                    postContent: <Icon name="Field18" />,
                    onClick: () => { handleRenameList(list) }
                },
                {
                    isAction: true,
                    text: t("general-delete"),
                    postContent: <Icon name="Delete18" />,
                    onClick: () => { handleDeleteList(list) }
                }
            ]}
        />
    </Stack>
    return {
        name: list.name,
        subscribers: formatNumber(partialListReport?.active_contacts || 0, genericWrapper.user?.language),
        click_rate: affixToPercent(partialListReport?.click_rate || 0, genericWrapper.user?.language),
        created_on: getCalendarFormat({ unixDate: list.created_on }),
        actions: actions
    }
}